//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { convertRequestFromServer } from '../../forms/Request/Request.js'

function deleteElementFromArray (array, element) {
  if (array && array.length && element != null) {
    const index = array.indexOf(element)
    if (index !== -1) {
      array.splice(index, 1)
    }
  }
}

export default {
  name: 'ReportMultiReportSelector',
  props: {
    multiReportRequests: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      requests: null,
      requestsSelected: [],
      allItemsSelected: false,
      fullRequests: null
    }
  },
  created: function () {
    const requestsInitial = this.multiReportRequests
    const requests = JSON.parse(JSON.stringify(requestsInitial))
    requests.forEach((request, index) => {
      const requestInitial = requestsInitial[index]
      request._initial = requestInitial
      request._expand = true
    })
    this.requests = requests
    this.requestsSelected = requests.filter(request => request._selected)
    this.updateAllItemsSelected()

    const requestsIds = requests.map(request => request.id)
    this.loadRequests(requestsIds).then(fullRequests => {
      this.fullRequests = fullRequests
      for (const request of requests) {
        const fullRequest = fullRequests.find(fullRequest => fullRequest.requestId === request.id)
        if (fullRequest) {
          request.descr = fullRequest.applicantDescription
          if (fullRequest.requestTypeObject) {
            request.type = fullRequest.requestTypeObject.name
          }
        }
      }
    })
  },
  methods: {
    onSelectedChange (request, selected) {
      this.setSelected(request, selected)
      this.updateAllItemsSelected()
    },
    setSelected (request, selected) {
      request._selected = selected

      if (selected) {
        this.requestsSelected.push(request)
      } else {
        deleteElementFromArray(this.requestsSelected, request)
      }
    },
    onApply () {
      // const selectedRequests = this.requests.filter(request => request._selected === true)
      this.$emit('apply', this.requestsSelected)
    },
    onCancel () {
      this.$emit('cancel')
    },

    onExpand: function (request) {
      request._expand = !request._expand
    },

    loadRequests: function (ids) {
      return axiosGet({
        url: '/service/delta/request/getRequests?id=' + ids.join(','),
        onSuccess: (response) => {
          const user = this.$store.getters.getUser
          return response.data.result.map(requestRaw => convertRequestFromServer(requestRaw, user))
        },
        onFailure: 'Ошибка получения информации по заявкам',
        msgTarget: this,
        throws: true
      })
    },

    onSelectAllItems: function (value) {
      this.allItemsSelected = value

      const items = this.requests
      for (const item of items) {
        this.setSelected(item, value)
      }
    },
    updateAllItemsSelected: function () {
      this.allItemsSelected = this.requests.length === this.requestsSelected.length
    }
  }
}
